import { TopPicksMediaPage } from './TopPicksMediaPage'

export function TopPicksMoviesPage() {
  return <TopPicksMediaPage mediaType="movie" />
}
